function init(state, value_name) {
  for (let i of value_name) {
    appendData(state, i);
  }
}
function appendData(state, name) {
  try {
    const val = localStorage.getItem(name);
    if (val !== null) {
      if (typeof state[name] === "string") {
        state[name] = val;
      } else {
        state[name] = JSON.parse(val);
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export default { init };
